import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import productDeleteModalStyles from "./ProductDeleteModal.styles";

const VariantTypeDeleteModal = ({ open, onClose, onConfirm, variantTypeName }) => {
  console.log("variantTypeName", variantTypeName);
  const styles = productDeleteModalStyles;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal 
      open={open} 
      onClose={(event, reason) => {
        console.log("event", event);
        if (reason === 'backdropClick') {
          return;
        }
        onClose();
      }}
    >
      <Box sx={styles.deleteModalContent}>
        <Typography sx={styles.deleteModalTitle}>
          Delete Variant Type?
        </Typography>
        <Typography sx={styles.deleteModalText}>
          Product variant Type will be deleted.
        </Typography>
        <Box sx={styles.deleteModalBtns}>
          <Button
            variant='outlined'
            color='primary'
            sx={styles.deleteModalCancelBtn}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            sx={styles.deleteModalYesBtn}
            onClick={handleConfirm}
          >
            Delete
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default VariantTypeDeleteModal;

